import styles from './LPFooter.module.scss'
import Column from 'components/home/Column'

type ServiceLink = [
  ...{
    href: string
    title: string
  }[],
]

interface CategoryLink {
  href: string
  title: string
}

const serviceLinks: ServiceLink[] = [
  [
    {
      href: '/services/servicedesign',
      title: 'サービスデザイン',
    },
    {
      href: '/services/designsprint',
      title: 'デザインスプリント',
    },
    {
      href: '/services/uiuxdesign',
      title: 'UX/UIデザイン',
    },
  ],
  [
    {
      href: '/services/od',
      title: '組織開発・イノベーション',
    },
    {
      href: '/services/mobileapp',
      title: 'モバイルアプリ',
    },
    {
      href: '/services/frontend',
      title: 'フロントエンド',
    },
  ],
  [
    {
      href: '/services/webapp',
      title: 'ウェブアプリ',
    },
    {
      href: '/services/xr',
      title: 'xR/アプリ開発',
    },
    {
      href: '/services/cloudservice',
      title: 'クラウド活用サービス',
    },
    {
      href: '/services/growthhack',
      title: 'サイト改善ソリューション',
    },
  ],
  [
    {
      href: '/services/appgrowth',
      title: 'プロダクトグロース・UX改善支援',
    },
  ],
]

const categoryLinks: CategoryLink[] = [
  {
    href: '/case',
    title: 'Case',
  },
  {
    href: '/about',
    title: 'About',
  },
  {
    href: '/topics/all/page/1',
    title: 'Topics',
  },
  {
    href: '/recruit',
    title: 'Recruit',
  },
  {
    href: '/download',
    title: 'Download',
  },
  {
    href: '/contact',
    title: 'Contact',
  },
]

const LPFooter: React.FC = () => {
  const serviceList = serviceLinks.map(
    (link, index): JSX.Element => (
      <ul className={`${styles.line}`} key={index}>
        {link.map(({ href, title }) => (
          <li key={title}>
            <a href={href} target="_blank" rel="noopener">
              <span className={styles.link_text}>{title}</span>
            </a>
          </li>
        ))}
      </ul>
    ),
  )

  const categoryList = categoryLinks.map(
    ({ href, title }): JSX.Element => (
      <a href={href} key={title} target="_blank" rel="noopener">
        <span className={styles.page_cotegoryLink}>{title}</span>
      </a>
    ),
  )

  return (
    <>
      <section className={styles.LPFooter}>
        <div className={styles.footer}>
          <div className={styles.address_group}>
            <img src="/img/common/logo_aitria.svg" className={styles.aitriaLogo} alt="Aitria" />
            <p className={`${styles.address} ${styles.zip}`}>〒107-0052</p>
            <p className={styles.address}>東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</p>
            <div className={styles.button}>
              <a
                href="https://www.google.co.jp/maps/place/Aitria+Co.,+Ltd./@35.673452,139.727701,17z/data=!3m1!5s0x60188b5ee42ea6b7:0xf9440bc4b8f6a3d5!4m5!3m4!1s0x60188ca66b638993:0x422d4622e50c7d!8m2!3d35.6599998!4d139.7080705?hl=ja"
                rel="noopener noreferrer"
                target="_blank"
                className={styles.toGoogleMap}
              >
                <img className={styles.pin} src="/images/lp2/GoogleMapPin.svg" alt="GoogleMap" />
                Google Map
              </a>
            </div>
          </div>
          <div className={`${styles.link_group}`}>
            <a href="/service/" target="_blank" rel="noopener">
              <span className={`${styles.page_cotegoryLink} ${styles.title}`}>Services</span>
            </a>
            <div className={styles.link_text_group}>{serviceList}</div>
            <div className={`${styles.normal_text} ${styles.page_inkline}`}>{categoryList}</div>
          </div>
        </div>
        <div className={styles.privacyCopylink}>
          <a className={styles.privacyPolicy} href="/privacy" target="_blank" rel="noopener">
            プライバシーポリシー
          </a>
          <p className={styles.copyright}>© Aitria Co., Ltd.</p>
        </div>
      </section>
    </>
  )
}

export default LPFooter
